import { render, staticRenderFns } from "./NavAll.vue?vue&type=template&id=48de55a7&scoped=true"
import script from "./NavAll.vue?vue&type=script&lang=js"
export * from "./NavAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48de55a7",
  null
  
)

export default component.exports